import TabPanel from '../Reusable/Tab';
//@ts-ignore
import { FileUpload } from '@careinfo/file-upload-service';
import EditVehicleManifest from './EditVehicleManifest';

const SwitchTab = (props: any) => {
  const {
    handleEdit,
    isLoading,
    data,
    id,
    handleCheckConsignments,
    handleAttachConsignment,
    handlePrint,
    gridData,
    isPrintLoading,
    handleSplitPrint,
    defaultValue,
    handleStatusChange,
    isRemoved,
    handleRemove,
    refetch,
  } = props;
  return (
    <>
      <TabPanel
        tabTitle={['Update', 'Documents']}
        tabPanels={[
          <>
            <EditVehicleManifest
              handleEdit={handleEdit}
              isLoading={isLoading}
              data={data}
              id={id}
              handleCheckConsignments={handleCheckConsignments}
              handleAttachConsignment={handleAttachConsignment}
              handlePrint={handlePrint}
              gridData={gridData}
              isPrintLoading={isPrintLoading}
              handleSplitPrint={handleSplitPrint}
              defaultValue={defaultValue}
              handleStatusChange={handleStatusChange}
              isRemoved={isRemoved}
              handleRemove={handleRemove}
              refetch={refetch}
            />
          </>,
          <>
            <FileUpload object_id={id} />
          </>,
        ]}
      />
    </>
  );
};

export default SwitchTab;
